// extracted by mini-css-extract-plugin
export default {"messageItem":"MessageLayout-module__messageItem--e782","sender":"MessageLayout-module__sender--7690","name":"MessageLayout-module__name--df33"};